// import clothing from './clothing';

// import { categories } from '../../categories';

export default {
  // [categories.clothing]: clothing,
};
